import environment from '../../config/environment.json';

function apiEndpoint() {
    return environment.apiEndpoint;
}

function adTenantId() {
    return environment.adTenantId;
}

function adClientId() {
    return environment.adClientId;
}

function adApiClientId() {
    return environment.adApiClientId;
}

export {
    apiEndpoint,
    adTenantId,
    adClientId,
    adApiClientId
};
